import script from "./userInfoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./userInfoForm.vue?vue&type=script&setup=true&lang=js"

import "./userInfoForm.vue?vue&type=style&index=0&id=35856bc2&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35856bc2"]])

export default __exports__